import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { SESSION_STORAGE_ACCOUNT_KEY, getSessionStorageItem } from '../../../../sessionStorage';

export default function SendStatusEmailButton(props) {
  const covrServicesUrl = process.env.REACT_APP_COVR_SERVICES_URL;

  const { passcode, birthdate, applicationID, clientUserID } = props;

  const [isClicked, setIsClicked] = useState(false);

  const sendStatusEmail = () => {
    fetch(`${covrServicesUrl}/api/AppStatus/SendStatusEmail`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'SessionId': getSessionStorageItem(SESSION_STORAGE_ACCOUNT_KEY).sessionId
      },
      body: JSON.stringify({
        passcode: passcode,
        birthdate: birthdate,
        applicationID: applicationID,
        clientUserID: clientUserID,
      }),
    });
  }

  const onClick = () => {
    if (isClicked) {
      return;
    }
    setIsClicked(true);
    sendStatusEmail();
  }

  return (
    <span>
      {isClicked === false &&
        <a href="" onClick={e => { e.preventDefault(); onClick(); }} variant="outlined">Resend email status link</a>
      }
      {isClicked && <p className="stepText">Status email sent.</p>}
    </span>
  )
}

SendStatusEmailButton.propTypes = {
  passcode: PropTypes.string.isRequired,
  birthdate: PropTypes.string.isRequired,
  applicationID: PropTypes.string.isRequired,
  clientUserID: PropTypes.string.isRequired
}


// WEBPACK FOOTER //
// ./src/components/Quoters/Common/Status/SendStatusEmailButton.js